<template>
    <div :class="[ (!bigLayout && !linkLayout) ? ( visible ? 'rounded py-6 lg:px-6 lg:bg-white lg:text-black border-b border-opacity-10 border-gray lg:border-none' :'py-6 border-b border-opacity-10 border-gray' ) : '']">
        <button v-if="bigLayout" class="w-full text-left" @click="toggle">
            <span class="flex justify-between items-center p-6 w-full text-base font-bold uppercase font-heading">
                <span class="mr-6">{{ title }}</span>
                <icon :class="[{ '-rotate-90': visible }, iconColor ? iconColor : 'text-red']"
                      class="justify-end w-4 h-4 transform rotate-90 fill-current"
                      name="chevron" />
            </span>
        </button>
        <button v-if="linkLayout" class="flex items-center" @click="toggle">
            <icon :class="{ 'rotate-90': visible }"
                  class="justify-end mr-4 w-4 h-4 transition-transform transform fill-current"
                  name="chevron" />
            <span class="font-bold">{{ title }}</span>
        </button>
        <button v-else-if="!visible && !bigLayout" class="text-left focus:outline-none" @click="toggle">
            <span class="flex items-center text-2xl font-bold uppercase font-heading">
                <icon :class="[iconColor ? iconColor : 'text-red']"
                      class="flex-shrink-0 mr-6 w-2.5 h-4 fill-current"
                      name="chevron" />
                <span class="opacity-50">{{ title }}</span>
            </span>
        </button>
        <collapse-transition v-show="visible">
            <div>
                <slot />
            </div>
        </collapse-transition>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import Icon from './Icon.vue';

@Component({
    components: {
        Icon,
        CollapseTransition
    }
})
export default class Accordion extends Vue {
    @Prop() title: string;
    @Prop() iconColor: string;
    @Prop({ default: false }) open!: boolean;
    @Prop({ default: '' }) group: string;
    @Prop({ default: false, type: Boolean }) bigLayout: boolean;
    @Prop({ default: false, type: Boolean }) linkLayout: boolean;

    visible = this.open;

    created() {
        this.$root.$on('accordion-open', this.onAccordionOpened);
    }

    beforeDestroy() {
        this.$root.$off('accordion-open', this.onAccordionOpened);
    }

    onAccordionOpened(group) {
        if (this.group === '') {
            return;
        }
        if (this.group === group) {
            this.visible = false;
        }
    }

    toggle() {
        if (!this.visible) {
            this.$root.$emit('accordion-open', this.group);
        }
        this.visible = !this.visible;
        this.$emit('toggle', this.visible);
    }
}

</script>
